import api from '@/services/api';
import type { ResolvedCampaign, CampaignConfigSetting } from '../types/campaign.types';

const smrPath = '/smr';

/**
 * Resolves a product's Campaign via the 1:1 product->campaign link (Plan A). Read-only
 * (no side effects); 404s when the product has not yet been provisioned a Campaign.
 */
export const resolveProductCampaign = async (productId: string): Promise<ResolvedCampaign> => {
    const response = await api.get(`${smrPath}/products/${productId}/campaign`);
    return (response.data.data ?? response.data) as ResolvedCampaign;
};

/** Current campaign-scoped config settings for the given campaign (Plan A). */
export const fetchCampaignConfigSettings = async (campaignId: string): Promise<CampaignConfigSetting[]> => {
    const response = await api.get(`${smrPath}/campaigns/${campaignId}/config-settings`);
    return (response.data.data ?? response.data) as CampaignConfigSetting[];
};
